import { render, staticRenderFns } from "./Recognition.vue?vue&type=template&id=342e4f5f&scoped=true"
import script from "./Recognition.vue?vue&type=script&lang=js"
export * from "./Recognition.vue?vue&type=script&lang=js"
import style0 from "./Recognition.vue?vue&type=style&index=0&id=342e4f5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342e4f5f",
  null
  
)

export default component.exports